import 'react-algolia/src/styles/rheostat.css';
import '../../css/vehicle/_list.scss';
import '../../css/vehicle/_item.scss';
import '../../css/vehicle/_panel_motor.scss';
import '../../css/common/_pagination.scss';
import '../../css/common/_block-list-link-seo.scss';

import Modal from "bootstrap.native/dist/components/modal-native.esm.js";
//import initItemVehicleClick from "../components/_item-vehicle-TEST";

const initToggleMobileMotor = () => {
    const openMobileMotorBtn = document.getElementById('mobileOpenMotor');
    const panelMotor = document.getElementById('panelMotor');
    let lastScrollY = 0;
    const sectionListFiltersMarginTop = document.querySelector('#sectionListFilters').getBoundingClientRect().top;
    const marginTopAfterClick = sectionListFiltersMarginTop-document.querySelector('#header').offsetHeight;

    if (openMobileMotorBtn && panelMotor) {
        const openMotorEvent = new CustomEvent('open-motor');

        document.addEventListener('open-motor', e => {
            panelMotor.classList.add('open');
            openMobileMotorBtn.classList.add('d-none');
            document.body.classList.add('overflow-hidden');
            document.body.classList.add('motor-open');
            document.body.classList.remove('motor-closed');
            lastScrollY = window.scrollY;
            window.scrollTo(0, 0);
            e.stopPropagation();
        });

        document.addEventListener('close-motor', e => {
            panelMotor.classList.remove('open');
            openMobileMotorBtn.classList.remove('d-none');
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('motor-open');
            document.body.classList.add('motor-closed');
            window.scrollTo(0, marginTopAfterClick);
            e.stopPropagation();
        });

        openMobileMotorBtn.addEventListener('click', e => {
            document.dispatchEvent(openMotorEvent);
        });
        //l'event' fermeture du moteur mobile est dispatché dans AlgoliaApp.js
    }
}

window.addEventListener('DOMContentLoaded', () => {

    initToggleMobileMotor();
    //initItemVehicleClick();

    /*************/
    // Stack BTN panel motor
    const mobileOpenMotor = document.querySelector('#mobileOpenMotor');
    const sectionListFilters = document.querySelector('#sectionListFilters');
    const headerHeight =  document.querySelector('#header').offsetHeight;

    if (window.matchMedia('(max-width: 768px)').matches) {
        window.addEventListener('scroll', function () {

            let sectionListFiltersMarginTop = document.querySelector('#sectionListFilters').getBoundingClientRect().top;
            if (sectionListFiltersMarginTop < headerHeight) {
                mobileOpenMotor.classList.add('position-fixed');
                mobileOpenMotor.style.top = (headerHeight + 20) + 'px';
            } else {
                mobileOpenMotor.classList.remove('position-fixed');
            }
        });

        // Renvoi à une ancre spécifique au chargement
        if ( sectionListFilters ) {
            const sectionListFiltersMarginTop = document.querySelector('#sectionListFilters').getBoundingClientRect().top;
            window.scroll({
                top: sectionListFiltersMarginTop - headerHeight,
                left: 0,
                behavior: 'smooth'
            });
        }

    }

});